import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Alert, Button, Container, Form, FormGroup, Input, Label, Row, Col, UncontrolledTooltip, Nav, NavLink, TabContent, TabPane } from 'reactstrap';
import fileDownload from 'js-file-download';
import moment from 'moment';
import PrintIcon from '@mui/icons-material/Print';

import AddIcon from '@mui/icons-material/AddOutlined';
import Address from '../components/common/Address';
import classnames from 'classnames';
import ContactList from '../components/contacts/List';
import ContactAddModal from '../components/poc/Modal';
import ProgramList from '../components/training/ProgramList';
import ProgramSearch from '../components/training/ProgramSearch';
import GridHeader from '../components/common/GridHeader';
import CourseList from '../components/course/List';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Documents from '../components/documents/Documents';
import FacultyList from '../components/training/FacultyList';
import FacultySearch from '../components/training/FacultySearch';
import Journal from '../components/common/Journal';
import Breadcrumb from '../components/MainMenuBreadcrumb';
import ControlledNumericInput from '../components/common/ControlledNumericInput';

import * as actions from '../actions/Training';
import { clearSearchedCourses, searchTrainingCourses, searchTrainingPrograms } from '../actions/Search';

import { getPerson } from '../actions/Person';
import { getCourse } from '../actions/Course';
import { getProjects } from '../actions/Projects';
import { clearProgramState, getAvailableProgramsList } from '../actions/Program';
import { getProgram, getPrograms, setLocation } from '../actions/Programs';
import { getTrainingTypes } from '../actions/TrainingTypes';
import { getTraining } from '../actions/Trainings';
import * as spinnerActions from '../actions/Spinner';

import { getAvailableFacultyList } from '../actions/Faculty';

import { apiGet, fetchReport } from '../utils/Api';
import { b64toBlob } from '../utils';
import { getOptionsFromListofMaps } from '../utils';

import ConfirmationModal from '../components/common/ConfirmationModal';
import CourseFacultyAssignment from '../components/training/CourseFacultyAssignment';


class Training extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            disableFacultyDelete: true,
            disableProgramsDelete: true,
            isDirty: false,
            showEndDateBeforeStartDate: false,
            showFollowupDateBeforeStartDate: false,
            showConfirmationModal: false,
            showFacultySearch: false,
            showProgramSearch: false,
            personsTrainedIsValid: true,
            preTestIsValid: true,
            postTestIsValid: true,
            overallEvaluationIsValid: true,
            showAddContactModal: false,
            contactPhoneIsValid: false,
            contactNameIsValid: false,
            withinGradeRange: false,
            activeTab: 'Info',
        };
    }

    componentDidMount() {
        this.props.actions.getProjects();
        this.props.actions.getPrograms();
        this.props.actions.getTrainingTypes();
        if (this.props.location.state && this.props.location.state.activeTab === "Programs") {
            this.setState({ activeTab: this.props.location.state.activeTab })
        }
    }

    handleSave = () => {

        const { startDate, endDate, followUpDate } = this.props.training.toJS();
        const training = this.props.training.set('sessionId', this.props.currentSessionId).toJS();

        const trainingStartDate = startDate ? moment(startDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.startDate).format(moment.HTML5_FMT.DATE)

        const trainingEndDate = endDate ? moment(endDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.endDate).format(moment.HTML5_FMT.DATE)

        const trainingFollowUpDate = followUpDate ? moment(followUpDate).format(moment.HTML5_FMT.DATE) :
            null;

        this.setState({ showEndDateBeforeStartDate: false, showFollowupDateBeforeStartDate: false });

        switch (this.canSaveTraining(trainingStartDate, trainingFollowUpDate, trainingEndDate, training)) {
            case "TrainingStartDateIsBeforeEndDate":
                this.setState({ showEndDateBeforeStartDate: true });
                break;
            case "TrainingFollowUpDateIsBeforeStartDate":
                this.setState({ showFollowupDateBeforeStartDate: true })
                break;
            case "SaveTraining":
                this.props.actions.updateTraining(training);
                this.props.trainingId && this.props.actions.saveTrainingCourseAssignments(this.props.trainingId, this.props.curriculum.toJS());
                this.setState({ showEndDateBeforeStartDate: false, showFollowupDateBeforeStartDate: false });
                break;
            default: break;
        }
        this.setState({ isDirty: false })
    };

    canSaveTraining = (trainingStartDate, trainingFollowUpDate, trainingEndDate, training) => {
        if (trainingEndDate < trainingStartDate) {
            return "TrainingStartDateIsBeforeEndDate";
        }
        else if (trainingFollowUpDate < trainingStartDate) {
            this.setState({ showFollowupDateBeforeStartDate: true })
            return "TrainingFollowUpDateIsBeforeStartDate";
        }
        else if (training.trainingTypeId)
            return "SaveTraining";
    }

    onDismissShowEndDateBeforeStartDate = () => {
        this.setState({ showEndDateBeforeStartDate: !this.state.showEndDateBeforeStartDate });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ isDirty: true })
        // The below block of code is being done for the calendar end date display issue. If a training doesn't
        // have a time if defauls to 12am on the date of. The calender will visually end the training on the day
        // before so we decided to add time to the end date thus making the training end date
        // correctly on the calendar
        if (name === 'endDate') {
            const addTimeForCalendarDisplay = moment(value).add(1, 'seconds')
            this.props.actions.setField(name, addTimeForCalendarDisplay);
        }
        else {
            this.props.actions.setField(name, value);
        }
    }

    handleFacultySearchToggle = () => {
        this.props.actions.getAvailableFacultyList(this.props.training.get('trainingId'));
        this.setState({ showFacultySearch: !this.state.showFacultySearch });
    }

    handleFacultySearchOnAdd = (personIds) => {
        this.handleFacultySearchToggle();
        this.props.actions.addTrainingFaculty(this.props.training.get('trainingId'), personIds);
    }

    handleProgramSearchToggle = () => {
        this.props.actions.searchTrainingPrograms(this.props.training.get('trainingId'));
        this.setState({ showProgramSearch: !this.state.showProgramSearch });
    }

    handleProgramSearchOnAdd = (programIds) => {
        this.handleProgramSearchToggle();
        this.props.actions.addTrainingPrograms(this.props.training.get('trainingId'), programIds);
    }

    handleProgramsOnSelectionChanged = (ids) => {
        this.selectedProgramIds = ids;
        this.setState({ disableProgramsDelete: !ids.length > 0 })
    }

    handleProgramsOnDelete = () => {
        this.props.actions.deleteTrainingPrograms(this.props.training.get('trainingId'), this.selectedProgramIds);
        this.setState({ disableProgramsDelete: true })
    }

    handleFacultyOnSelectionChanged = (ids) => {
        this.selectedFacultyPersonIds = ids
        this.setState({ disableFacultyDelete: !ids.length > 0 })
    };

    handleFacultyDelete = () => {
        this.props.actions.deleteTrainingFaculty(this.props.training.get('trainingId'), this.selectedFacultyPersonIds);
        this.setState({ disableFacultyDelete: true })
    }

    cancelAddTraining = (facultyChange = false) => {
        if (this.state.isDirty === true || facultyChange === true)
            this.setState({ showConfirmationModal: true })
        else
            this.props.history.push(`/home`);
    }

    addressChanged = () => { this.setState({ isDirty: true }) }

    getTimeZones = () => {
        const options = [<option key={0} value={''} disabled>Select Time Zones</option>];

        this.props.timeZones.forEach((timeZone, index) => {
            options.push(<option key={index + 1} value={timeZone.lookupId}>{timeZone.name}</option>);
        });

        return options;
    }

    handleEventTypeChange = (e) => {
        this.props.actions.updateEventType(e.currentTarget.value)
    }

    handleTimeZoneChange = (e) => {
        this.props.actions.updateTimeZone(e.currentTarget.value)
    }

    handleToggleConfirmationModal = (e) => { this.setState({ showConfirmationModal: !this.state.showConfirmationModal }) }

    handleCancelAddTraining = () => {
        this.props.history.push(`/home`);
    }

    handleProgramDelete = () => this.props.actions.deleteTrainingFaculty(this.props.training.get('trainingId'), this.selectedProgramIds);

    handleSearchCourses = (searchTerm) => this.props.actions.searchTrainingCourses(this.props.training.get('trainingId'), searchTerm);

    handleAddFromSearch = (selectedCourses, addSections) => this.props.actions.addTrainingCurriculum(this.props.training.get('trainingId'), selectedCourses.map(x => x.courseId), addSections);

    handleDeleteCourses = (selectedCourses) => this.props.actions.deleteTrainingCurriculum(this.props.training.get('trainingId'), selectedCourses);

    handleToggleTab = (tab) => this.setState({ activeTab: tab });

    handleFacultyOnSelect = (id) => {
        this.props.actions.getPerson(id);
        this.props.history.push(`/persons/person/${id}`);
    }

    handleDocumentsClick = () => this.props.actions.getTrainingDocuments(this.props.training.get('trainingId'));

    handleAddFiles = (type, files) => this.props.actions.addTrainingDocument(this.props.training.get('trainingId'), type, files);

    handleDocumentTypeChange = (type) => this.props.actions.getTrainingDocumentsByType(this.props.training.get('trainingId'), type);

    handleDocumentSave = (trainingDocumentId, documentTypeId) => this.props.actions.updateTrainingDocument(this.props.trainingId, trainingDocumentId, documentTypeId);

    handleDocumentDelete = (type, id) => this.props.actions.deleteTrainingDocument(this.props.training.get('trainingId'), type, id);

    handleSaveTrainingJournalEntry = (journalEntry) => {
        const trainingId = this.props.training.get('trainingId');
        const trainingJournalEntry =
            journalEntry.id ?
                {
                    trainingId,
                    trainingJournalEntryId: journalEntry.id,
                    isActive: true,
                    ...journalEntry
                }
                :
                {
                    trainingId,
                    isActive: true,
                    ...journalEntry
                };

        return this.props.actions.saveTrainingJournalEntry(this.props.training.get('trainingId'), trainingJournalEntry);
    }

    handleGetTrainingJournalEntry = (id) =>
        apiGet(`${process.env.REACT_APP_API_HOST}api/training/journal/${id}`)
            .then(res => ({ ...res, id: res.trainingJournalEntryId }));

    handleDeleteTrainingJournalEntries = (ids) => this.props.actions.deleteTrainingJournalEntries(this.props.training.get('trainingId'), ids);

    handleProgramsChange = (programIds) => this.props.actions.updateTrainingPrograms(programIds);

    handleOnContactSelected = (id) => {
        this.props.actions.getPerson(id);
        this.props.history.push(`/persons/person/${id}`);
    }

    handlePrint = (personIds) => {
        this.props.actions.spin();
        fetchReport('reports/GeneralConsultantAgreement', { trainingId: this.props.training.get('trainingId'), personIds: this.selectedFacultyPersonIds }).then(() => this.props.actions.dontSpin());
    }

    handleToggleShowAddContactModal = () => this.setState({ showAddContactModal: !this.state.showAddContactModal });

    handleToggleContactPhoneIsValid = (isValid) => {
        if (this.state.contactPhoneIsValid !== isValid)
            this.setState({ contactPhoneIsValid: isValid });
    };

    handleToggleContactNameIsValid = (isValid) => {
        if (this.state.contactNameIsValid !== isValid)
            this.setState({ contactNameIsValid: isValid });
    };

    handleAddContact = (contact) => this.props.actions.addTrainingContact(this.props.trainingId, { trainingId: this.props.trainingId, person: contact, isActive: true });

    handleDeleteContacts = (ids) => this.props.actions.deleteTrainingContacts(this.props.trainingId, ids);

    handleAddContactFromSearch = (persons) => {
        const contacts = persons.map(x =>
        (
            {
                trainingId: this.props.trainingId,
                personId: x.personId,
                isActive: true
            }
        )
        );
        this.props.actions.addTrainingContacts(this.props.trainingId, contacts);
    }

    handleOnContactSearch = (searchTerm) => this.props.actions.searchContacts(this.props.trainingId, searchTerm);

    handleTrainingLocationChange = (e) => {
        const { target: { name, value } } = e;
        this.props.actions.setTrainingLocation(this.props.currentSessionId, name, value);
    };


    getTrainingLocation = () => {
        const options = [<option key={0} value={''} disabled>Select a Training Location</option>];
        this.props.trainingLocationTypes.forEach((location, index) => {
            options.push(<option key={index + 1} value={location.lookupId}>{location.name}</option>);
        });
        return options;
    }

    handleTrainingOnSelect = () => { }

    handlePersonsTrainedChange = (canSave) => {
        canSave === true ? this.setState({ personsTrainedIsValid: true }) : this.setState({ personsTrainedIsValid: false })
    }

    handlePreTestChange = (canSave) => {
        canSave === true ? this.setState({ preTestIsValid: true }) : this.setState({ preTestIsValid: false })
    }

    handlePostTestChange = (canSave) => {
        canSave === true ? this.setState({ postTestIsValid: true }) : this.setState({ postTestIsValid: false })
    }

    handleOverallEvaluationChange = (canSave) => {
        canSave === true ? this.setState({ overallEvaluationIsValid: true }) : this.setState({ overallEvaluationIsValid: false })
    }

    render() {
        const { trainingId, followUpDate, projectId, trainingTypeId, startDate, endDate, address, virtualLocation, trainingLocationTypeId, timeZoneId } = this.props.training.toJS();

        const personsTrained = this.props.training.get('personsTrained');
        const pretest = this.props.training.get('pretest');
        const posttest = this.props.training.get('posttest');
        const overallEvaluation = this.props.training.get('overallEvaluation');
        const trainingStartDate = startDate ? moment(startDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.startDate).format(moment.HTML5_FMT.DATE)
        const trainingEndDate = endDate ? moment(endDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.endDate).format(moment.HTML5_FMT.DATE)
        return (
            <React.Fragment>
                {<ConfirmationModal
                    isOpen={this.state.showConfirmationModal}
                    onToggle={this.handleToggleConfirmationModal}
                    onConfirm={this.handleCancelAddTraining}
                    modalHeader={'Confrim Cancel'}
                    modalBody={'You have unsaved data, are you sure you want to continue?'}
                />}
                <Container>
                    <div style={{ paddingBottom: '10px' }}>
                        <Breadcrumb history={this.props.history} />
                    </div>
                    <Alert color="warning" isOpen={this.state.showEndDateBeforeStartDate} fade={true}>
                        Training end date cannot occur before training start date
                    </Alert>
                    <Alert color="warning" isOpen={this.state.showFollowupDateBeforeStartDate} toggle={this.onDismissShowFollowupDateNotInRange}>
                        Training follow up date cannot occur before training start date
                    </Alert>
                    <Alert color="warning" isOpen={this.state.showFollowupDateBeforeStartDate} toggle={this.onDismissShowFollowupDateNotInRange}>
                        Training follow up date cannot occur before training start date
                    </Alert>
                    <Form>
                        <Nav tabs>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Info' })}
                                onClick={() => { this.handleToggleTab('Info'); }}
                            >
                                Info
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Location' })}
                                onClick={() => { this.handleToggleTab('Location'); }}
                            >
                                Location
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Programs' })}
                                onClick={() => { this.handleToggleTab('Programs'); }}
                                disabled={!trainingId}
                            >
                                Programs
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Curriculum' })}
                                onClick={() => { this.handleToggleTab('Curriculum'); }}
                                disabled={!trainingId}
                            >
                                Curriculum
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Faculty' })}
                                onClick={() => { this.handleToggleTab('Faculty'); }}
                                disabled={!trainingId}
                            >
                                Faculty
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'CourseFacultyAssignments' })}
                                onClick={() => { this.handleToggleTab('CourseFacultyAssignments'); }}
                                disabled={!trainingId}
                            >
                                Faculty Assignments
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Contacts' })}
                                onClick={() => { this.handleToggleTab('Contacts'); }}
                                disabled={!trainingId}
                            >
                                Contacts
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Documents' })}
                                onClick={() => { this.handleToggleTab('Documents'); }}
                                disabled={!trainingId}
                            >
                                Documents
                            </NavLink>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Notes' })}
                                onClick={() => { this.handleToggleTab('Notes'); }}
                                disabled={!trainingId}
                            >
                                Notes
                            </NavLink>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Info">
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Project:</Label>
                                            <Input type='select' name='projectId' onChange={this.handleChange} value={projectId || ''}>
                                                {getOptionsFromListofMaps(this.props.projects, 'projectId', 'name')}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>Type:</Label>
                                            <Input type='select' name='trainingTypeId' onChange={this.handleChange} value={trainingTypeId || ''}
                                                invalid={!trainingTypeId}
                                            >
                                                {getOptionsFromListofMaps(this.props.trainingTypes, 'trainingTypeId', 'name')}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Start Date:</Label>
                                            <Input type='date' max="2999-12-31" name='startDate' onChange={this.handleChange} value={trainingStartDate || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>End Date:</Label>
                                            <Input type='date' max="2999-12-31" name='endDate' onChange={this.handleChange} value={trainingEndDate || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>Follow Up:</Label>
                                            <Input name='followUpDate' max="2999-12-31" type="date" size="3" onChange={this.handleChange} value={followUpDate ? moment(followUpDate).format('YYYY-MM-DD') : ''} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <ControlledNumericInput
                                                label='Persons Trained'
                                                name='personsTrained'
                                                maxLengthToUse={6}
                                                min='0'
                                                max='999999'
                                                numberValue={Math.trunc(personsTrained) || ''}
                                                disableSave={this.handlePersonsTrainedChange}
                                                setField={this.props.actions.setField}
                                                isValid={this.state.personsTrainedIsValid}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <ControlledNumericInput
                                                label='Pretest'
                                                name='pretest'
                                                min='1'
                                                max='999999'
                                                maxLengthToUse={6}
                                                numberValue={Math.trunc(pretest) || ''}
                                                disableSave={this.handlePreTestChange}
                                                setField={this.props.actions.setField}
                                                isValid={this.state.preTestIsValid}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <ControlledNumericInput
                                                label='Posttest'
                                                name='posttest'
                                                min='0'
                                                max='999999'
                                                maxLengthToUse={6}
                                                numberValue={Math.trunc(posttest) || ''}
                                                disableSave={this.handlePostTestChange}
                                                setField={this.props.actions.setField}
                                                isValid={this.state.postTestIsValid}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <ControlledNumericInput
                                                label='Overall Evaluation'
                                                name='overallEvaluation'
                                                maxLengthToUse={6}
                                                min='0.01'
                                                max='999999'
                                                step='0.01'
                                                numberValue={overallEvaluation || ''}
                                                disableSave={this.handleOverallEvaluationChange}
                                                setField={this.props.actions.setField}
                                                isValid={this.state.overallEvaluationIsValid}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className='pt-3'>
                                    <Col className='d-flex flex-row-reverse'>
                                        <Button onClick={this.handleSave} disabled={!trainingTypeId || this.state.preTestIsValid === false || this.state.postTestIsValid === false
                                            || this.state.overallEvaluationIsValid === false || this.state.personsTrainedIsValid === false}>Save</Button>
                                        <Button className='me-1' onClick={this.cancelAddTraining}>Cancel</Button>
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Location">
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label style={{ fontSize: '1.75rem' }}><h3 style={{ paddingTop: '.55em' }}>Training Location</h3></Label>
                                            <Input name='trainingLocationTypeId' type='select' onChange={this.handleTrainingLocationChange} value={trainingLocationTypeId || ''}>
                                                {this.getTrainingLocation()}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Address
                                            fromTraining={true}
                                            {...address}
                                            states={this.props.states}
                                            onChange={this.props.actions.setLocationField}
                                            addressChanged={this.addressChanged}
                                            fromTrainingPage={true}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Time Zone:</Label>
                                            <Input name='timeZoneId' type='select' id='timeZone' onChange={this.handleChange} value={timeZoneId || ''}>
                                                {this.getTimeZones()}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Virtual Location:</Label>
                                            <Input type='textarea' name="virtualLocation" rows='3' value={virtualLocation || ''} onChange={this.handleChange}></Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className='pt-3'>
                                    <Col className='d-flex flex-row-reverse'>
                                        <Button onClick={this.handleSave}>Save</Button>
                                        <Button className='me-1' onClick={this.cancelAddTraining}>Cancel</Button>
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>

                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Contacts">
                                <Row className='pt-3'>
                                    <Col>
                                        {this.state.activeTab === 'Contacts' &&
                                            <React.Fragment>
                                                <ContactList
                                                    title='Points of Contact'
                                                    data={this.props.trainingContacts}
                                                    onAdd={this.handleToggleShowAddContactModal}
                                                    onDelete={this.handleDeleteContacts}
                                                    onSelect={this.handleOnContactSelected} ii
                                                    onSearch={this.handleOnContactSearch}
                                                    searchResults={this.props.personSearchResults}
                                                    onAddFromSearch={this.handleAddContactFromSearch}
                                                    clearTrainingContactSearch={this.props.actions.clearTrainingContactSearch}
                                                    recordId='trainingContactId'
                                                />
                                                <ContactAddModal
                                                    toggleValidState={this.handleToggleContactNameIsValid}
                                                    toggleContactPhoneIsValid={() => this.handleToggleContactPhoneIsValid}
                                                    contactPhoneIsValid={this.state.contactPhoneIsValid}
                                                    contactNameIsValid={this.state.contactNameIsValid}
                                                    isOpen={this.state.showAddContactModal}
                                                    toggle={this.handleToggleShowAddContactModal}
                                                    states={this.props.states}
                                                    phoneTypes={this.props.phoneTypes}
                                                    properTitles={this.props.properTitles}
                                                    generations={this.props.generations}
                                                    personTypes={this.props.personTypes}
                                                    addressTypes={this.props.addressTypes}
                                                    onAdd={this.handleAddContact}
                                                />
                                            </React.Fragment>
                                        }
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>

                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Faculty">
                                {this.state.activeTab === 'Faculty' &&
                                    <React.Fragment>
                                        <Row className='pt-3 mb-1'>
                                            <Col>
                                                <h3>Faculty</h3>
                                            </Col>
                                            <Col className='d-flex flex-row-reverse'>
                                                <Button id='deletePersonnelButton' disabled={this.state.disableFacultyDelete} onClick={this.handleFacultyDelete}><DeleteIcon /></Button>
                                                <Button id='addPersonnelButton' onClick={this.handleFacultySearchToggle} className='me-1'><AddIcon /></Button>
                                                <Button id='printConsultantAgreement' onClick={this.handlePrint} className='me-1'><PrintIcon /></Button>
                                                <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='printConsultantAgreement'>Print Faculty Member(s).</UncontrolledTooltip>
                                                <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='addPersonnelButton'>Add faculty to the training.</UncontrolledTooltip>
                                                <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target='deletePersonnelButton'>Delete faculty from the training.</UncontrolledTooltip>
                                            </Col>
                                        </Row>
                                        <Row className='pt-0'>
                                            {this.state.activeTab === 'Faculty' &&
                                                <Col>
                                                    <FacultyList
                                                        history={this.props.history}
                                                        data={this.props.faculty.toJS()}
                                                        onSelect={this.handleFacultyOnSelectionChanged}
                                                        getPerson={this.props.actions.getPerson}
                                                    />
                                                    <FacultySearch
                                                        isOpen={this.state.showFacultySearch}
                                                        toggle={this.handleFacultySearchToggle}
                                                        data={this.props.availableFaculty.toJS()}
                                                        onAdd={this.handleFacultySearchOnAdd}
                                                        personnelTypes={this.props.personnelTypes}
                                                    />
                                                </Col>
                                            }
                                        </Row>
                                    </React.Fragment>
                                }
                            </TabPane>
                        </TabContent>

                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Curriculum">
                                <Row className='pt-3'>
                                    <Col>
                                        {this.state.activeTab === 'Curriculum' &&
                                            <CourseList
                                                title='Curriculum'
                                                clearSearchedCourses={this.props.actions.clearSearchedCourses}
                                                fromTraining={true}
                                                history={this.props.history}
                                                getCourse={this.props.actions.getCourse}
                                                courses={this.props.curriculum.toJS()}
                                                hideAddButton={true}
                                                onSearch={this.handleSearchCourses}
                                                onAddFromSearch={this.handleAddFromSearch}
                                                searchResults={this.props.searchResults && this.props.searchResults.toJS()}
                                                onDelete={this.handleDeleteCourses}
                                                showOptions={true}
                                                toolTip='courses or sessions'
                                            />
                                        }
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>

                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Documents">
                                <Row className='pt-3'>
                                    <Col>
                                        {this.state.activeTab === 'Documents' &&
                                            <Documents
                                                title={'Training Documents:'}
                                                documentTypes={this.props.trainingDocumentTypes}
                                                onAddFiles={this.handleAddFiles}
                                                onTypeChange={this.handleDocumentTypeChange}
                                                onDownload={this.handleDocumentDownload}
                                                onDelete={this.handleDocumentDelete}
                                                onSave={this.handleDocumentSave}
                                                data={this.props.documents.toJS()}
                                                getEntityId={(x) => x.trainingDocumentId}
                                            />
                                        }
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Notes">
                                <Row className='pt-3'>
                                    <Col>
                                        {this.state.activeTab === 'Notes' &&
                                            <Journal
                                                title='Training Notes:'
                                                data={this.props.journal}
                                                onGet={this.handleGetTrainingJournalEntry}
                                                onSave={this.handleSaveTrainingJournalEntry}
                                                onDelete={this.handleDeleteTrainingJournalEntries}
                                            />
                                        }
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="CourseFacultyAssignments">
                                <CourseFacultyAssignment
                                    courses={this.props.curriculum.toJS()}
                                    handleSave={this.handleSave}
                                    cancelSave={this.cancelAddTraining}
                                    faculty={this.props.faculty.filter(x => {
                                        const assignedFaculty = this.props.curriculum.get('faculty');
                                        return !assignedFaculty ? true : !assignedFaculty.find(f => f.get('personId') === x.get('personId'));
                                    }).toJS()}

                                    onAdd={this.props.actions.addCourseFaculty}
                                    onRemove={this.props.actions.removeCourseFaculty}
                                />
                            </TabPane>
                        </TabContent>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="Programs">
                                {this.state.activeTab === 'Programs' &&
                                    <React.Fragment>
                                        <Row className='pt-3 mb-1'>
                                            <GridHeader
                                                gridEntities='Programs'
                                                deleteButtonId='deleteProgramButton'
                                                disableDelete={this.state.disableProgramsDelete}
                                                onDeleteClick={this.handleProgramsOnDelete}
                                                addButtonId='addProgramButton'
                                                onAddClick={this.handleProgramSearchToggle}
                                                addTooltipTarget={'addProgramButton'}
                                                deleteTooltipTarget={'deleteProgramButton'}
                                                tooltipEntity={'Program'}
                                            />
                                        </Row>
                                        <Row className='pt-0'>
                                            {this.state.activeTab === 'Programs' &&
                                                <Col>
                                                    <ProgramList
                                                        disableDelete={this.state.disableProgramsDelete}
                                                        getProgram={this.props.actions.getProgram}
                                                        history={this.props.history}
                                                        trainingPrograms={this.props.trainingPrograms}
                                                        onSelectionChanged={this.handleProgramsOnSelectionChanged}
                                                    />
                                                    <ProgramSearch
                                                        getProgram={this.props.actions.getProgram}
                                                        history={this.props.history}
                                                        trainingId={trainingId}
                                                        clearProgramState={this.props.actions.clearProgramState}
                                                        setLocation={this.props.actions.setLocation}
                                                        fromTrainingPage={this.props.fromTrainingPage}
                                                        history={this.props.history}
                                                        isOpen={this.state.showProgramSearch}
                                                        toggle={this.handleProgramSearchToggle}
                                                        data={this.props.programs}
                                                        onAdd={this.handleProgramSearchOnAdd}
                                                    />
                                                </Col>
                                            }
                                        </Row>
                                    </React.Fragment>
                                }
                            </TabPane>
                        </TabContent>
                    </Form >
                </Container >
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        startDate: state.TrainingData.get('startDate'),
        endDate: state.TrainingData.get('endDate'),
        training: state.TrainingData.get('training'),
        curriculum: state.TrainingData.get('curriculum'),
        documents: state.TrainingData.get('documents'),
        faculty: state.TrainingData.get('faculty'),
        journal: state.TrainingData.get('journal').toJS(),
        virtualLocation: state.TrainingData.get('virtualLocation'),
        trainingLocationTypeId: state.TrainingData.getIn(['training', 'trainingLocationTypeId']),
        projects: state.Projects,
        programs: state.SearchResults.get('programs').toJS(),
        trainingTypes: state.TrainingTypes,
        currentSessionId: parseInt(state.login.getIn(['context', 'user', 'claims'])
            .find(x => x.get('claimType') === 'ACT.CurrentSession').get('claimValue'), 10),
        availableFaculty: state.SearchResults.get('faculty'),
        searchResults: state.SearchResults.get('courses'),
        trainingContacts: state.TrainingData.get('contacts').toJS(),
        trainingPrograms: state.TrainingData.get('programs').toJS(),
        trainingId: state.TrainingData.getIn(['training', 'trainingId']),
        fromTrainingPage: state.ProgramData.get('fromTrainingPage'),
        personSearchResults: state.SearchResults.get('persons').toJS(),
        timeZones: state.StaticData.get('timeZones').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...actions,
            ...spinnerActions,
            clearSearchedCourses,
            getCourse,
            getProjects,
            getPrograms,
            getProgram,
            getTraining,
            getAvailableFacultyList,
            getAvailableProgramsList,
            getPerson,
            getTrainingTypes,
            searchTrainingCourses,
            searchTrainingPrograms,
            setLocation,
            clearProgramState
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Training);
